module.exports = __webpack_public_path__ + "img/minus@1x.eeb2bb0a.svg";